export const sysColor = {
  primary: '#6d2ef8', // 主色
  text: '#1d1c23', // 文字主色
}



// WEBPACK FOOTER //
// ./src/public/config/color.js